import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-primary-600">404</h1>
                    <h2 className="text-3xl font-bold text-gray-900 mt-4 mb-2">Page Not Found</h2>
                    <p className="text-gray-600">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        className="inline-flex items-center justify-center px-6 py-3 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-700 transition-colors"
                    >
                        <Home className="w-5 h-5 mr-2" />
                        Go Home
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="inline-flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5 mr-2" />
                        Go Back
                    </button>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Looking for something specific?
                    </p>
                    <div className="flex flex-wrap justify-center gap-4 mt-4">
                        <Link to="/products" className="text-primary-600 hover:text-primary-700 font-medium">
                            Products
                        </Link>
                        <Link to="/about" className="text-primary-600 hover:text-primary-700 font-medium">
                            About Us
                        </Link>
                        <Link to="/contact" className="text-primary-600 hover:text-primary-700 font-medium">
                            Contact
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
